import React from 'react';
import { Link } from 'react-router-dom';
import { X, Trash2, Plus, Minus, ShoppingBag, ArrowRight } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import './CartDrawer.css';

export default function CartDrawer() {
  const { items, isOpen, setIsOpen, removeItem, updateQuantity, subtotal, shippingCost, tax, total, itemCount } = useCart();

  if (!isOpen) return null;

  return (
    <>
      <div className="cart-overlay" onClick={() => setIsOpen(false)} />
      <div className="cart-drawer">
        <div className="cart-header">
          <h2><ShoppingBag size={20} /> Cart ({itemCount})</h2>
          <button className="cart-close" onClick={() => setIsOpen(false)}><X size={22} /></button>
        </div>

        {items.length === 0 ? (
          <div className="cart-empty">
            <ShoppingBag size={60} />
            <p>Your cart is empty</p>
            <Link to="/shop" className="btn-primary" onClick={() => setIsOpen(false)}>Browse Products</Link>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {items.map(item => (
                <div key={item._id} className="cart-item">
                  <img
                    src={item.thumbnail || 'https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=100'}
                    alt={item.name}
                    className="cart-item-img"
                  />
                  <div className="cart-item-info">
                    <p className="cart-item-name">{item.name}</p>
                    <p className="cart-item-price">CHF {item.price.toFixed(2)}</p>
                    <div className="cart-qty-controls">
                      <button onClick={() => updateQuantity(item._id, item.quantity - 1)}><Minus size={14} /></button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateQuantity(item._id, item.quantity + 1)} disabled={item.quantity >= item.stock}><Plus size={14} /></button>
                    </div>
                  </div>
                  <div className="cart-item-right">
                    <p className="cart-item-total">CHF {(item.price * item.quantity).toFixed(2)}</p>
                    <button className="cart-remove" onClick={() => removeItem(item._id)}><Trash2 size={16} /></button>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-summary">
              <div className="summary-row"><span>Subtotal</span><span>CHF {subtotal.toFixed(2)}</span></div>
              <div className="summary-row"><span>Shipping</span><span>{shippingCost === 0 ? <span style={{color:'var(--success)'}}>Free</span> : `CHF ${shippingCost.toFixed(2)}`}</span></div>
              <div className="summary-row"><span>VAT (7.7%)</span><span>CHF {tax.toFixed(2)}</span></div>
              {subtotal < 50 && <p className="free-shipping-hint">Add CHF {(50 - subtotal).toFixed(2)} more for free shipping!</p>}
              <div className="summary-total"><span>Total</span><span>CHF {total.toFixed(2)}</span></div>
              <Link to="/checkout" className="btn-gold checkout-btn" onClick={() => setIsOpen(false)}>
                Checkout <ArrowRight size={18} />
              </Link>
              <Link to="/cart" className="view-cart-link" onClick={() => setIsOpen(false)}>View full cart</Link>
            </div>
          </>
        )}
      </div>
    </>
  );
}
